<template>
    <b-card bg-variant="light">
        <div class="text-center">
            <span v-show="$i18n.locale === 'ko'" class="fw-300">
                본 시스템은 
                <a href="https://www.google.com/intl/ko/chrome/" v-bind="commonAttr">
                    <b-img class="ml-1" :style="imgCommonStyleObj" src="/images/chrome_i.svg" alt="" /> Google Chrome
                </a> 또는 <br class="d-block d-md-none" />
                <a href="https://www.microsoft.com/ko-kr/edge" v-bind="commonAttr">
                    <b-img class="ml-1" :style="imgCommonStyleObj" src="/images/edge.svg" alt="" /> Microsoft Edge
                </a> 에 최적화되어있습니다.
            </span>
            <span v-show="$i18n.locale !== 'ko'" class="fw-300">
                {{ this.$t('본 시스템은 Google Chrome 또는 Microsoft Edge에 최적화되어 있음을 알려드립니다. (ex. 인터넷익스플로러는 출력 사용불가)') }}
            </span>  
        </div>
    </b-card>
</template>

<script>
export default {
    name: 'browser-support-guide',
    data: () => ({
        commonAttr: {
            target: '_blank',
            class: 'dark-a'
        },
        imgCommonStyleObj: {
            width: '17px',
            height: '17px'
        }
    }),
    computed: {},
    watch: {},
    created () {},
    methods: {}
}
</script>

<style>

</style>